export const LABOUR_TYPE = 'WORK';
